<template>
  <div
    class="container-fluid promotion-page p-2 pt-3"
    style="height: 100vh; overflow-y: scroll; padding-bottom: 15rem;"
  >
    <button
      type="button"
      class="btn btn-link text-dark px-1"
      @click="$router.back()"
    >
      {{ label('Back', 'နောက်သို့') }}
    </button>

    <div
      v-if="loading"
      class="text-center text-muted py-5"
    >
      {{ label('Loading...', 'ဆောင်ရွက်နေသည်...') }}
    </div>

    <div
      v-else-if="!promotion"
      class="text-center text-muted py-5"
    >
      {{ label('Promotion not found.', 'ပရိုမိုးရှင်း မတွေ့ပါ။') }}
    </div>

    <div
      v-else
      class="card bg-white mx-1 mb-5"
    >
      <img
        v-if="promotion.image"
        :src="promotion.image"
        class="card-img-top"
        :alt="promotion.name"
      >
      <div class="card-body">
        <h2 class="text-dark">{{ promotion.name }}</h2>

        <div
          v-if="promotion.claim_once_per_user && promotion.claimed"
          class="alert alert-warning"
        >
          {{ label('You have already claimed this promotion.', 'ဤပရိုမိုးရှင်းကို ရယူပြီးသားဖြစ်ပါသည်။') }}
        </div>

        <div
          v-if="promotion.description"
          class="text-muted mb-3"
          v-html="promotion.description"
        />

        <div class="row">
          <div
            v-for="item in infoItems"
            :key="item.key"
            class="col-6 col-md-4 mb-2"
          >
            <div class="border rounded p-2 h-100">
              <div class="small text-muted">{{ item.label }}</div>
              <div class="font-weight-bold">{{ item.value }}</div>
            </div>
          </div>
        </div>

        <button
          v-if="isNoDeposit"
          type="button"
          class="btn btn-info btn-block mt-3"
          :disabled="claiming || promotion.claimed"
          @click="claimPromotion"
        >
          <span v-if="claiming">{{ label('Loading...', 'လုပ်ဆောင်နေသည်...') }}</span>
          <span v-else-if="promotion.claimed">
            {{ promotion.claim_once_per_user
              ? label('You have already claimed this promotion.', 'ဤပရိုမိုးရှင်းကို ရယူပြီးသားဖြစ်ပါသည်။')
              : label('Already claimed', 'ရယူပြီးသား') }}
          </span>
          <span v-else>
            {{ label('Claim promotion', 'ပရိုမိုးရှင်း ရယူမည်') }}
            <template v-if="promotion.fixed_bonus_amount">
              ({{ promotion.fixed_bonus_amount }})
            </template>
          </span>
        </button>

        <router-link
          v-else
          class="btn btn-info btn-block mt-3"
          to="/deposit"
        >
          {{ label('Deposit to claim', 'ငွေသွင်းပြီး ရယူမည်') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';

export default {
  data() {
    return {
      promotion: null,
      loading: true,
      claiming: false,
    };
  },
  computed: {
    isNoDeposit() {
      const promotion = this.promotion;
      if (!promotion) return false;
      const requiresDeposit = promotion.requires_deposit;
      const noDeposit = requiresDeposit === false
        || requiresDeposit === 0
        || String(requiresDeposit).toLowerCase() === 'false'
        || String(requiresDeposit) === '0';
      return noDeposit && promotion.fixed_bonus_amount != null && promotion.fixed_bonus_amount !== '';
    },
    infoItems() {
      const promotion = this.promotion;
      if (!promotion) return [];
      const items = [];
      const push = (key, label, value) => {
        if (value !== null && value !== undefined && value !== '') {
          items.push({ key, label, value: String(value) });
        }
      };

      push('total_quantity', this.label('Total quantity', 'စုစုပေါင်းအရေအတွက်'), promotion.total_quantity);
      push('available_quantity', this.label('Available quantity', 'ရရှိနိုင်သည့်အရေအတွက်'), promotion.available_quantity);
      push('daily_limit', this.label('Daily limit', 'နေ့စဉ်ကန့်သတ်ချက်'), promotion.daily_usage_limit);
      if (promotion.claim_once_per_user) {
        push('claim_once', this.label('Claim once per user', 'တစ်ဦးလျှင် တစ်ကြိမ်သာ'), this.label('Yes', 'ဟုတ်ကဲ့'));
      }
      const claimable = Number(promotion.claimable_amount);
      if (Number.isFinite(claimable) && claimable > 0) {
        push('claimable_amount', this.label('Claimable amount', 'ရယူရန် လိုအပ်သော ပမာဏ'), claimable.toLocaleString());
      }
      if (promotion.promotion_percent != null && promotion.promotion_percent !== '') {
        push('bonus_pct', this.label('Bonus %', 'ဘောနပ်စ် %'), `${promotion.promotion_percent}%`);
      }
      push('fixed_bonus', this.label('Fixed bonus', 'သတ်မှတ်ဘောနပ်စ်'), promotion.fixed_bonus_amount);
      push('min_turn_over', this.label('Min. turn over', 'အနည်းဆုံးလည်ပတ်ငွေ'), promotion.minimum_turn_over_amount);
      push('min_withdraw_times', this.label('Min. withdraw times', 'အနည်းဆုံးထုတ်ယူမှုအကြိမ်'), promotion.minimum_withdraw_times);
      if (promotion.requires_deposit !== undefined && promotion.requires_deposit !== null) {
        push(
          'requires_deposit',
          this.label('Requires deposit', 'ငွေသွင်းရမည်'),
          promotion.requires_deposit ? this.label('Yes', 'ဟုတ်ကဲ့') : this.label('No', 'မဟုတ်ပါ'),
        );
      }
      push('date_type', this.label('Date type', 'ရက်အမျိုးအစား'), promotion.date_type);
      return items;
    },
  },
  mounted() {
    this.fetchPromotion();
  },
  methods: {
    label(en, mm) {
      return this.$store.state.language === 'en' ? en : mm;
    },
    translateClaimError(error) {
      const raw = String(error?.response?.data?.message || '').trim();
      if (raw === 'You have already claimed this promotion.' || raw === 'Already claimed') {
        return this.label(
          'You have already claimed this promotion.',
          'ဤပရိုမိုးရှင်းကို ရယူပြီးသားဖြစ်ပါသည်။',
        );
      }
      const match = raw.match(/^The minimum deposit amount for this promotion is (.+)\.$/);
      if (match) {
        return this.label(
          `The minimum deposit amount for this promotion is ${match[1]}.`,
          `ဤပရိုမိုးရှင်းအတွက် အနည်းဆုံး ငွေသွင်းပမာဏမှာ ${match[1]} ဖြစ်ပါသည်။`,
        );
      }
      return raw || this.label('Claim failed', 'ရယူ၍မရပါ');
    },
    async fetchPromotion() {
      this.loading = true;
      try {
        const { data } = await axios.get(`/promotions/${this.$route.params.id}`);
        this.promotion = data.data ?? (data?.id ? data : null);
      } catch (error) {
        console.error(error);
        this.promotion = null;
      } finally {
        this.loading = false;
      }
    },
    async claimPromotion() {
      if (!this.promotion?.id || this.claiming || this.promotion.claimed) return;
      if (!localStorage.getItem('token')) {
        this.$router.push('/auth/login');
        return;
      }

      this.claiming = true;
      try {
        await axios.post(`/user/promotions/${this.promotion.id}/claim`, {});
        Toast.success(this.label('Promotion claimed successfully', 'ပရိုမိုးရှင်း ရယူပြီးပါပြီ'));
        this.promotion = { ...this.promotion, claimed: true };
        if (this.fetchUser) {
          await this.$store.dispatch('fetchUser');
        }
        await this.fetchPromotion();
      } catch (error) {
        Dialog.alert({
          message: this.translateClaimError(error),
          confirmButtonText: this.label('OK', 'အိုကေ'),
        });
        if (error?.response?.status === 409) {
          this.promotion = { ...this.promotion, claimed: true };
        }
      } finally {
        this.claiming = false;
      }
    },
  },
};
</script>

<style scoped>
.promotion-page {
  background: linear-gradient(180deg, #eed1f6 0%, #fdf4fc 22%, #ffffff 55%, #fdf4fc 100%);
}

.promotion-page .btn-info {
  background: linear-gradient(135deg, #f179e2 0%, #DD4DD1 55%, #714DC7 100%);
  border-color: #714DC7;
  color: #fff;
}
</style>
